import { render, staticRenderFns } from "./YearlyReportTable.vue?vue&type=template&id=40f71071&scoped=true&"
import script from "./YearlyReportTable.vue?vue&type=script&lang=js&"
export * from "./YearlyReportTable.vue?vue&type=script&lang=js&"
import style0 from "./YearlyReportTable.vue?vue&type=style&index=0&id=40f71071&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f71071",
  null
  
)

export default component.exports